// eslint-disable-next-line import/no-cycle
import { getArchivedChatsV2 } from './getArchivedChatsV2';
import { getLastTimeStamp } from '../../reducers/chatList/helpers';
import { TThunkAction } from '../../types/redux/thunk';

export const getArchivedListNextPage = (): TThunkAction<void> => (dispatch, getState) => {
  const state = getState();
  const { chatList } = state;

  const timestampArchive = chatList.isFirstLoad
    ? undefined
    : chatList.chats.length
      ? getLastTimeStamp(chatList.chats)
      : state.chatList.timestampArchive;

  dispatch(getArchivedChatsV2({ timestampArchive }));
};
